import React from 'react';
import { Box, Container, Stack, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const StyledFooter = styled('footer')(({ theme }) => ({
    //backgroundColor: THEME_ACTIVE.FOOTER,
    padding: theme.spacing(4, 0),
    borderTop: `1px solid ${theme.palette.divider}`,
    '& a': {
        color: theme.palette.text.primary,
        textDecoration: 'none',
        fontSize: '0.8rem',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
}));

const FooterSection = styled(Stack)(({ theme }) => ({
    flex: 1,
    minWidth: '250px',  // Ensures sections don't get too narrow
    [theme.breakpoints.down('md')]: {
        minWidth: '100%'
    }
}));

const Footer: React.FC = () => {
    return (
        <StyledFooter>
            <Container maxWidth="lg">
                {/* Main footer content */}
                <Stack spacing={2}>
                    {/* Top sections */}
                    <Stack
                        direction={{ xs: 'row', md: 'row' }}
                        spacing={{ xs: 2, md: 2 }}
                        justifyContent="space-between"
                        alignItems="flex-start"
                    >
                        {/* Contact Section */}
                        <FooterSection sx={{
                            display: { xs: 'none', sm: 'flex' },
                            flexDirection: 'row',
                            alignItems: { xs: 'center', md: 'flex-start' },
                            flex: 1,
                            justifyContent: "space-between"
                        }}>
                            <Link component={RouterLink} to="/contact">
                                Contact Us
                            </Link>
                            <Typography
                                sx={{
                                    fontSize: '0.8rem',
                                    textAlign: { xs: 'center', md: 'left' },
                                    whiteSpace: { xs: 'normal', sm: 'nowrap' },
                                    wordBreak: { xs: 'break-word', sm: 'normal' }
                                }}
                            >
                                Phone: <Link href="tel:+16196639330">(619) 663-9330</Link>
                                &nbsp;&nbsp;|&nbsp;&nbsp;
                                Email: <Link href="mailto:crew@pointsails.com">crew@pointsails.com</Link>
                            </Typography>
                            <Stack spacing={1} direction="row" sx={{ gap: 2 }}>
                                <Link component={RouterLink} to="/privacy-policy">
                                    Privacy Policy
                                </Link>
                                <Link component={RouterLink} to="/warranty">
                                    Warranty
                                </Link>
                            </Stack>
                        </FooterSection>

                        {/* Mobile Footer - Two rows */}
                        <Box sx={{ display: { xs: 'flex', sm: 'none' }, flexDirection: 'column', width: '100%', gap: 1 }}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Link component={RouterLink} to="/contact">
                                    Contact Us
                                </Link>
                                <Typography sx={{ fontSize: '0.8rem' }}>
                                    <Link href="tel:+16196639330">(619) 663-9330</Link>
                                </Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography sx={{ fontSize: '0.8rem' }}>
                                    <Link href="mailto:crew@pointsails.com">crew@pointsails.com</Link>
                                </Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Link component={RouterLink} to="/privacy-policy">
                                    Privacy Policy
                                </Link>
                                <Link component={RouterLink} to="/warranty">
                                    Warranty
                                </Link>
                            </Stack>
                        </Box>

                        {/* Resources Section */}
                        {/*<FooterSection sx={{*/}
                        {/*    display: 'flex',*/}
                        {/*    flexDirection: 'column',*/}
                        {/*    alignItems: { xs: 'center', md: 'flex-start' }*/}
                        {/*}}>*/}

                        {/*</FooterSection>*/}

                        {/* Follow Us Section */}
                        {/*<FooterSection sx={{*/}
                        {/*    display: 'flex',*/}
                        {/*    flexDirection: 'column',*/}
                        {/*    alignItems: { xs: 'center', md: 'flex-start' }*/}
                        {/*}}>*/}
                        {/*    */}{/*<Typography*/}
                        {/*    */}{/*    variant="footerHeader"*/}
                        {/*    */}{/*    sx={{ textAlign: { xs: 'center', md: 'left' } }}*/}
                        {/*    */}{/*>*/}
                        {/*    */}{/*    Follow Us*/}
                        {/*    */}{/*</Typography>*/}
                        {/*    */}{/*<Stack spacing={1}>*/}
                        {/*    */}{/*    */}{/* Add social media links when needed */}
                        {/*    */}{/*</Stack>*/}
                        {/*</FooterSection>*/}
                    </Stack>
                    {/* Trust tagline and locations */}
                    <Box
                        sx={{
                            pt: 2,
                            borderTop: '1px solid',
                            borderColor: 'divider',
                            textAlign: 'center'
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '0.8rem',
                                color: 'text.secondary',
                                mb: 0.5
                            }}
                        >
                            Trusted by San Diego sailors for decades — now available nationwide.
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '0.75rem',
                                color: 'text.secondary'
                            }}
                        >
                            San Diego, CA &nbsp;•&nbsp; Lincoln City, OR
                        </Typography>
                    </Box>

                    {/* Copyright line */}
                    <Box
                        sx={{
                            pt: 2,
                            borderTop: '0px solid',
                            borderColor: 'divider'
                        }}
                    >
                        <Typography
                            variant="body2"
                            align="center"
                        >
                            © 2026 Point Sails NW - All Rights Reserved
                        </Typography>
                    </Box>
                </Stack>
            </Container>
        </StyledFooter>
    );
};

export default Footer;